import { border, fontSize, fontWeight } from "@mui/system";

export const classes = {
    tableHeader: {
        fontSize: "16px",
        fontWeight: "bold"
    },
    filter: {
        mt: 3,
        ml: 1,
        fontSize: "16px",
        fontWeight: "bold"
    },
    tablecell: {
        border: "none"
    },
    FormControl: {
        m: 1,
        minWidth: 208,
        width: { xs: "100%", sm: "100%", lg: 0, md: 0 }
    }
}